import { createSlice } from 'redux-starter-kit'
import { defaultViewport } from '../config'
import getCenter from '../utils/getCenter'

function fetchMapSuccess(state, action) {
  const { results } = action.payload

  return { ...state, ...results, fetching: false, error: false }
}

function setBoundingBox(state, action) {
  const bbox = action.payload
  console.log(bbox)
  return {...state, bbox}
}

function setExternalViewport(state, action){
  const [[bx, by], [tx, ty]] = state.bbox
   const [lat, long] = action.payload.slice(3,5)
  console.log([lat, long])
  console.log(((lat <= tx) && (lat >=bx)) &&  ((long <= ty) && (long >=by)))
  if (((lat <= tx) && (lat >=bx)) &&  ((long <= ty) && (long >=by)) ){
    return state
  }
  // setViewport(state, action)
    const center = [lat, long]
  const viewport = [lat, long, 13]
    return { ...state, center, viewport}



}

function setViewport(state, action) {
  console.log('yo')
    console.log(action)

  const coords = action.payload.slice(3,5)
  const center = [coords[0], coords[1]]
  let viewport = [coords[0], coords[1], 13]
  const zoom = 13

  return { ...state, center, viewport}
}

function setItem(state, action) {
  const { item } = action.payload

  return { ...state, item }
}

const mapDuck = createSlice({
  slice: 'map',
  initialState: {
    fetching: false,
    error: false,
    viewport: defaultViewport,
    center: [defaultViewport.longitude, defaultViewport.latitude],

    zoom: [defaultViewport.zoom],

    loading: true,
    bbox : []
  },
  reducers: {
    fetchMapSuccess,
    setBoundingBox,
    setItem,
    setViewport, setExternalViewport
  }
})

export default mapDuck



// WEBPACK FOOTER //
// ./src/redux/mapDuck.js